import { Image } from '@chakra-ui/react';
import React from 'react';
import logo from '@/assets/goldenbet888/images/sideNav/logoSidenav.png';

export default function Index() {
  return <Image src={logo} maxH="54px" />;
}
